import { STATUS_CHECKED, STATUS_COMPLETED, STATUS_CREATED, STATUS_DATA_COMPLETED } from "./leadStatus";
import Button from "@mui/material/Button";
import React from "react";
import { getCaseLink, getProductData } from "@/src/services/productService";
import { STATUS_IN_PROGRESS } from "@/src/services/contractLaw/leadStatus";
import _get from "lodash/get";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";
import dayjs from "dayjs";
import { Link } from "react-router";

const getContent = (familyLawCase: AbstractCase) => {
  const appointmentStatus = _get(familyLawCase, "advisoryAppointment.status");
  const appointmentDate = _get(familyLawCase, "advisoryAppointment.appointment.date") && dayjs(_get(familyLawCase, "advisoryAppointment.appointment.date"));

  switch (familyLawCase.leadStatus) {
    case STATUS_CREATED:
      return {
        header: "Ihr Anliegen",
        text: "Beschreiben Sie hier kurz Ihr Anliegen. Danach können Sie direkt einen Termin für Ihr Erstgespräch buchen.",
        buttonTarget: getCaseLink(familyLawCase) + "/antrag",
        buttonLabel: "Fall schildern",
      };
    case STATUS_DATA_COMPLETED:
    case STATUS_CHECKED:
      return {
        header: "Jetzt Termin vereinbaren",
        text: "Vielen Dank für die Schilderung Ihres Falls. Sie können jetzt einen Termin für eine Erstberatung vereinbaren",
        buttonTarget: getCaseLink(familyLawCase) + familyLawCase.calendlyLink,
        buttonLabel: "Termin vereinbaren",
      };
    case STATUS_IN_PROGRESS:
      if (appointmentStatus === "not_processed") {
        return {
          header: "Ihr Termin konnte nicht stattfinden",
          text: `Sie hatten einen Termin für ein Erstgespräch am ${
            appointmentDate && appointmentDate.format("DD.MM.YYYY")
          } gebucht. Der Termin konnte nicht stattfinden. Buchen Sie sich gerne einen neuen Termin.`,
          buttonTarget: getCaseLink(familyLawCase) + familyLawCase.calendlyLink,
          buttonLabel: "Neuen Termin buchen",
        };
      }

      return {
        header: "Termin erfolgreich gebucht",
        text:
          `Sie haben einen Termin für ein Erstgespräch am ${appointmentDate && appointmentDate.format("DD.MM.YYYY")} gebucht.` +
          ` Ihr Rechtsanwalt wird Sie um ${appointmentDate && appointmentDate.format("HH:mm")} Uhr anrufen.`,
      };
    case STATUS_COMPLETED:
      return {
        header: "Ihr Fall ist abgeschlossen",
        text: "Vielen Dank für Ihr Vertrauen und dafür, dass wir Sie unterstützen durften! Sie sind der Meinung, dass ihr Fall nicht abgeschlossen ist oder es sind im Nachgang doch noch Probleme aufgetreten? Dann schreiben Sie uns gerne jederzeit eine Nachricht und wir werden selbstverständlich umgehend für Sie tätig!",
      };
    default:
      return {
        header: "Technischer Fehler",
        text: "Leider kam es scheinbar zu einem technischen Fehler in Ihrem Fall. Bitte melden Sie sich per E-Mail an service@legalbird.de, damit wir Ihnen zeitnah weiterhelfen können.",
      };
  }
};

const getButton = (familyLawCase: AbstractCase) => {
  const content: Record<string, any> = getContent(familyLawCase);
  if (!content.buttonLabel) {
    return null;
  }
  return (
    <Button
      component={Link}
      to={content.linkType === "external" ? { pathname: content.buttonTarget } : content.buttonTarget}
      target={content.linkType === "external" ? "_blank" : undefined}
      variant="contained"
      color="primary"
      fullWidth
    >
      {content.buttonLabel}
    </Button>
  );
};

const getPercentage = (familyLawCase: AbstractCase) => {
  switch (familyLawCase.leadStatus) {
    case STATUS_CREATED:
      return 50;
    case STATUS_DATA_COMPLETED:
    case STATUS_CHECKED:
      return 66;
    case STATUS_IN_PROGRESS:
      return 75;
    case STATUS_COMPLETED:
      return 100;
    default:
      return 0;
  }
};

export const getStatusBoxConfigFamilyLawCase = (familyLawCase: AbstractCase) => {
  const content = getContent(familyLawCase);
  return {
    header: content.header,
    text: content.text,
    ctaButton: getButton(familyLawCase),
    productName: getProductData(familyLawCase.name, "label"),
    percentage: getPercentage(familyLawCase),
  };
};
